// src/components/GoogleReviews.js
import React, { useEffect, useState } from "react";
import ApiService,{initialAuthState} from "../Services/ApiServices";
import axios from "axios";

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        const response = await ApiService.get("/reviews"); // your backend endpoint
        // const response = await axios.get("http://localhost:3000/api/reviews");
        setReviews(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load reviews");
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  if (loading) return <p>Loading reviews...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {reviews.map((review, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #ddd",
            padding: "10px",
            borderRadius: "8px",
            background: "#f9f9f9",
          }}
        >
          <strong>{review.author_name}</strong> ({review.rating}⭐)
          <p>{review.text}</p>
        </div>
      ))}
    </div>
  );
};

export default GoogleReviews;